import { benefits } from "@/components/data/benefits";

const Benefits = () => {
  return (
    <section id="beneficios" className="py-12 lg:py-20 bg-secondary/30 scroll-mt-24">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 lg:mb-4">
            Por que escolher o escritorio Galvao & Silva Advocacia?
          </h2>
          <p className="text-base lg:text-xl text-muted-foreground max-w-3xl mx-auto px-4">
            Somos especialistas em direito bancario e revisao contratual, com atendimento personalizado para cada caso.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div
                key={index}
                className="bg-card p-6 lg:p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow border border-border/50"
              >
                <div className="w-12 h-12 lg:w-14 lg:h-14 rounded-full bg-accent/10 flex items-center justify-center mb-4 lg:mb-6">
                  <Icon className="w-6 h-6 lg:w-7 lg:h-7 text-accent" />
                </div>
                <h3 className="text-lg lg:text-xl font-bold text-foreground mb-2 lg:mb-3">
                  {benefit.title}
                </h3>
                <p className="text-sm lg:text-base text-muted-foreground leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
